import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

const routesP = [
    {
      path: '/',
      name: 'Index',
      component: () => import('@/views/pc/index.vue')
    },
    {
      path: '/profile',
      name: 'profile',
      component: () => import('@/views/pc/profile.vue')
    },
    {
      path: '/culture',
      name: 'culture',
      component: () => import('@/views/pc/culture.vue')
    },
    {
      path: '/partner',
      name: 'partner',
      component: () => import('@/views/pc/partner.vue')
    },
    {
      path: '/contact',
      name: 'contact',
      component: () => import('@/views/pc/contact.vue')
    },
    {
      path: '/privacy',
      name: 'Privacy',
      component: () => import('@/views/pc/privacy.vue')
    },
    {
      path: '/classic',
      name: 'classic',
      component: () => import('@/views/pc/classic.vue')
    },
    {
      path: '/media',
      name: 'media',
      component: () => import('@/views/pc/media.vue')
    },
    {
      path: '/branding',
      name: 'branding',
      component: () => import('@/views/pc/branding.vue')
    },
    {
      path: '/publicrelations',
      name: 'publicrelations',
      component: () => import('@/views/pc/publicrelations.vue')
    },
    {
      path: '/tourism',
      name: 'tourism',
      component: () => import('@/views/pc/tourism.vue')
    },
    {
      path: '/digital',
      name: 'digital',
      component: () => import('@/views/pc/digital.vue')
    },
    {
      path: '/park',
      name: 'park',
      component: () => import('@/views/pc/park.vue')
    },
    {
      path: '/finance',
      name: 'finance',
      component: () => import('@/views/pc/finance.vue')
    },
    {
      path: '/newscenter',
      name: 'newscenter',
      component: () => import('@/views/pc/newscenter.vue')
    },
    {
      path: '/newslist',
      name: 'newslist',
      component: () => import('@/views/pc/newslist.vue')
    },
    {
      path: '/newsdetail',
      name: 'newsdetail',
      component: () => import('@/views/pc/newsdetail.vue')
    },
    {
      path: '/joinus',
      name: 'JoinUs',
      component: () => import('@/views/pc/joinus.vue')
    },
    {
      path: '/job',
      name: 'Job',
      component: () => import('@/views/pc/job.vue')
    },
    {
      path: '/resume',
      name: 'Resume',
      component: () => import('@/views/pc/resume.vue')
    }
  ]
  const routesM = [
    {
      path: '/',
      name: 'Index',
      component: () => import('@/views/mobile/index.vue')
    },
    {
      path: '/profile',
      name: 'profile',
      component: () => import('@/views/mobile/profile.vue')
    },
    {
      path: '/culture',
      name: 'culture',
      component: () => import('@/views/mobile/culture.vue')
    },
    {
      path: '/partner',
      name: 'partner',
      component: () => import('@/views/mobile/partner.vue')
    },
    {
      path: '/contact',
      name: 'contact',
      component: () => import('@/views/mobile/contact.vue')
    },
    {
      path: '/privacy',
      name: 'Privacy',
      component: () => import('@/views/mobile/privacy.vue')
    },
    {
      path: '/classic',
      name: 'classic',
      component: () => import('@/views/mobile/classic.vue')
    },
    {
      path: '/media',
      name: 'media',
      component: () => import('@/views/mobile/media.vue')
    },
    {
      path: '/branding',
      name: 'branding',
      component: () => import('@/views/mobile/branding.vue')
    },
    {
      path: '/publicrelations',
      name: 'publicrelations',
      component: () => import('@/views/mobile/publicrelations.vue')
    },
    {
      path: '/tourism',
      name: 'tourism',
      component: () => import('@/views/mobile/tourism.vue')
    },
    {
      path: '/digital',
      name: 'digital',
      component: () => import('@/views/mobile/digital.vue')
    },
    {
      path: '/park',
      name: 'park',
      component: () => import('@/views/mobile/park.vue')
    },
    {
      path: '/finance',
      name: 'finance',
      component: () => import('@/views/mobile/finance.vue')
    },
    {
      path: '/joinus',
      name: 'JoinUs',
      component: () => import('@/views/mobile/joinus.vue')
    },{
      path: '/job',
      name: 'Job',
      component: () => import('@/views/mobile/job.vue')
    },
    {
      path: '/resume',
      name: 'Resume',
      component: () => import('@/views/mobile/resume.vue')
    }, {
      path: '/newscenter',
      name: 'newscenter',
      component: () => import('@/views/mobile/newscenter.vue')
    },
    {
      path: '/newsdetail',
      name: 'newsdetail',
      component: () => import('@/views/mobile/newsdetail.vue')
    }
  ]
var routes = [];
if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) && window.screen.width < 1200) {
  routes = routesM//手机端独立
  // routes = routesP//自适应手机
} else {
  routes = routesP
}
const router = new Router({
  mode: 'history',
  routes
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js